module.exports = __webpack_public_path__ + "static/media/icon-salesforce.f646f652.svg";